export default "__VITE_ASSET__CTSaln45__"